import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'activeOutlet',
            'startDate',
            'endDate',
            'startYear',
            'endYear',
            'dateFilter',
            'monthFilter',
            'yearFilter',
        ]),

        /**
         * Encoded url params
         */
        filterParams() {
            const param = Object.assign(
                { outlet_id: this.activeOutlet },
                this.dateFilter,
                this.monthFilter,
                this.yearFilter,
            );

            return $.param(param);
        },
    },

    watch: {
        activeOutlet(newVal, oldVal) {
            this.$emit('outlet-changed', newVal);
        },

        dateFilter(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.$emit('date-changed', newVal);
        },

        monthFilter(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.$emit('month-changed', newVal);
        },

        yearFilter(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.$emit('year-changed', newVal);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/report-filter.js